import { FC, useEffect, useState } from 'react';
import { Checkbox, Col, Divider, Row, Segmented, Typography } from 'antd';
import { TbChevronRightPipe, TbColumns, TbSubtask } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useUserStore } from '@/stores';

interface OptionsProps {
    segmented: any;
    setSegmented: any;
    accountingFormat: any;
    setAccountingFormat: any;
    plainOptions: any;
    checkedList: any;
    onChange: any;
}

const Options: FC<OptionsProps> = ({
    segmented,
    setSegmented,
    accountingFormat,
    setAccountingFormat,
    plainOptions,
    checkedList,
    onChange,
}): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const navigate = useNavigate();
    const { selectedUser: user } = useUserStore();

    const { token } = useAntDesignTheme();

    return (
        <>
            <Typography.Title level={5}>3. Spreadsheet Options</Typography.Title>
            <Row gutter={[16, 0]}>
                <Col span={12}>
                    <Row style={{ marginBottom: '0.5rem' }}>
                        <Col flex='auto'>
                            <small style={{ color: token.colorTextTertiary }}>
                                <TbSubtask style={{ verticalAlign: '-0.1rem', marginRight: '0.25rem' }} />
                                Tabs
                            </small>
                        </Col>
                    </Row>
                    <Divider style={{ margin: '0.5rem 0' }} />
                    <div>
                        {plainOptions.map((option: any) => (
                            <div key={option} style={{ marginBottom: '0.25rem' }}>
                                <Checkbox
                                    checked={checkedList.includes(option)}
                                    onChange={(e) => onChange(e.target.checked, option)}
                                >
                                    {option}
                                </Checkbox>
                            </div>
                        ))}
                    </div>
                </Col>
                <Col span={12}>
                    <Row>
                        <Col flex='auto'>
                            <small style={{ color: token.colorTextTertiary }}>
                                <TbChevronRightPipe style={{ verticalAlign: '-0.1rem', marginRight: '0.25rem' }} />
                                Formatting
                            </small>
                        </Col>
                    </Row>
                    <Divider style={{ margin: '0.5rem 0' }} />
                    <Row style={{ marginBottom: '0.5rem' }}>
                        <Col flex='auto'>
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='0.825rem'
                                height='0.825rem'
                                viewBox='0 0 24 24'
                                fill='none'
                                stroke='currentColor'
                                strokeWidth='2'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                className='lucide lucide-text-initial-icon lucide-text-initial'
                                style={{ verticalAlign: '-0.15rem', marginRight: '0.25rem' }}
                            >
                                <path d='M15 5h6' />
                                <path d='M15 12h6' />
                                <path d='M3 19h18' />
                                <path d='m3 12 3.553-7.724a.5.5 0 0 1 .894 0L11 12' />
                                <path d='M3.92 10h6.16' />
                            </svg>
                            Data Format
                        </Col>
                        <Col flex='none'>
                            <Segmented
                                options={[
                                    { value: 'normalized', label: 'Normalized' },
                                    { value: 'asReported', label: 'As Reported (SEC.gov)' },
                                ]}
                                size='small'
                                value={accountingFormat}
                                onChange={(value: any) => {
                                    setAccountingFormat(value);
                                }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col flex='auto'>
                            <TbColumns style={{ verticalAlign: '-0.15rem', marginRight: '0.25rem' }} />
                            Column Format
                        </Col>
                        <Col flex='none'>
                            <Segmented
                                size='small'
                                options={[
                                    { value: 'annual', label: 'Years' },
                                    { value: 'quarter', label: 'Quarters' },
                                ]}
                                style={{}}
                                value={segmented}
                                onChange={(value: any) => {
                                    setSegmented(value);
                                }}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default Options;
